module.exports = __webpack_public_path__ + "static/media/Jam4.b086ac69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/Jam4.svg
// module id = 605
// module chunks = 0